import { render } from "./LeaveReview.vue?vue&type=template&id=0fb8fb64&scoped=true"
import script from "./LeaveReview.vue?vue&type=script&lang=js"
export * from "./LeaveReview.vue?vue&type=script&lang=js"

import "./LeaveReview.vue?vue&type=style&index=0&id=0fb8fb64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb8fb64"]])

export default __exports__